import { InfotextDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/infotext-display-model';
import { Directive, HostListener, Input } from '@angular/core';
import { StammdatenService } from '@/core/services/stammdaten.service';
import { StateService } from '@/core/services/state.service';

@Directive({
  selector: '[appinfotext]'
})
export class InfoTextDirective {

  @Input("appinfotext") schluessel = '';

  constructor(protected stateService: StateService, protected stammdatenService: StammdatenService) {    
  } 

  @HostListener('focus') onMouseEnter() {
    let entry = this.stammdatenService.InfoTexte?.getValue(this.schluessel);
    if(entry)
      this.stateService.setFieldInfoText(entry);
    else
    {
      entry = new InfotextDisplayModel();
      entry.schluessel = this.schluessel;
      this.stateService.setFieldInfoText(entry);
    }
  }
  
  @HostListener('blur') onMouseLeave() {
    this.stateService.clearFieldInfoText();
  }
}
